import React from 'react';
import _ from 'lodash';

import { isValidPassword } from 'helpers/Account';
import ChangePassword from '../AccountComponents/ChangePassword';

import Style from '../SharedStyles/SharedStyles.module.scss';

const INVALID_PASSWORD = 'invalid loginid or password';

function setChangePasswordErrors(cb, name) {
  const { changePasswordPassword, changePasswordNewPassword } = this.state;
  const changePasswordPasswordError = !isValidPassword(changePasswordPassword);
  const changePasswordNewPasswordError = !isValidPassword(changePasswordNewPassword);
  const setStateCb = () => {
    const { changePasswordPasswordError, changePasswordNewPasswordError } = this.state;
    const hasErrors = changePasswordPasswordError || changePasswordNewPasswordError || false;
    if (cb) return cb(hasErrors);
    return hasErrors;
  };

  if (name) {
    switch (name) {
      case 'changePasswordPasswordError':
        this.setState({ changePasswordPasswordError }, setStateCb);
        break;
      case 'changePasswordNewPasswordError':
        this.setState({ changePasswordNewPasswordError }, setStateCb);
        break;
      default:
        break;
    }
  } else {
    return this.setState(
      {
        changePasswordPasswordError,
        changePasswordNewPasswordError,
      },
      setStateCb,
    );
  }
  return null;
}

function onChangePassword() {
  const {
    editAccount,
    language: { profileError_passwordLength: passwordLengthErrorText },
  } = this.props;
  const { changePasswordPassword, changePasswordNewPassword } = this.state;

  if (changePasswordNewPassword.length < 6) {
    this.setState({
      changePasswordGenericError: passwordLengthErrorText,
    });

    return;
  }

  const handleSuccess = () => {
    this.toggleChangePassword();
    this.toggleAccountMain();
  };

  setChangePasswordErrors.bind(this)(hasErrors => {
    if (!hasErrors && editAccount) {
      const body = {
        password: changePasswordPassword,
        newPassword: changePasswordNewPassword,
      };
      editAccount(body, result => {
        const { error } = result;
        const detailError = _.get(error, 'detail', '');
        let errorMessage = _.get(error, 'message', '');
        if (detailError.toLowerCase() === INVALID_PASSWORD) {
          errorMessage = _.get(window, 'Language.profile_incorrectPasswordUpdate', errorMessage);
        }
        if (error) return this.setState({ changePasswordGenericError: errorMessage });
        return handleSuccess.bind(this)();
      });
    }
  });
}

function onChangePasswordBackClick() {
  this.toggleChangePassword();
  this.toggleAccountMain();
}

export default function renderChangePassword() {
  const {
    language: { profileChangePw_header: headerText, profileSignin_forgotPasswordText: linkText },
    language,
    backgroundClass,
    isMobile,
  } = this.props;
  const {
    changePasswordPassword,
    changePasswordNewPassword,
    changePasswordShowPassword,
    changePasswordShowNewPassword,
    changePasswordGenericError,
    changePasswordPasswordError,
    changePasswordNewPasswordError,
    showChangePassword,
  } = this.state;
  const changePasswordBackClick = onChangePasswordBackClick.bind(this);
  const changePassword = onChangePassword.bind(this);
  const forgotPasswordCTAProps = {
    linkText,
    onClick: () => {
      if (this.onForgotPasswordClick) this.onForgotPasswordClick();
    },
  };
  const headerProps = {
    headerText,
    iconMobile: <button onClick={() => changePasswordBackClick()} className={Style.back} />,
    isDesktop: !isMobile,
    onClose: this.onClose,
    renderLogo: this.renderLogo,
    showHeaderDesktop: true,
  };
  const changePasswordProps = {
    backgroundClass,
    changePasswordGenericError,
    changePasswordNewPassword,
    changePasswordNewPasswordError,
    changePasswordPassword,
    changePasswordPasswordError,
    changePasswordShowNewPassword,
    changePasswordShowPassword,
    forgotPasswordCTAProps,
    headerProps,
    language,
    onChangePassword: changePassword,
    onChangePasswordBackClick: changePasswordBackClick,
    onFieldChange: this.onFieldChange,
  };
  if (!showChangePassword) return null;
  return <ChangePassword {...changePasswordProps} />;
}
